import { FETCH_SETTINGS, FETCH_SETTINGS_SUCCESS, FETCH_SETTINGS_ERROR } from './constants';

export const initialState = {
  settingsResponse: null,
};

// eslint-disable-next-line default-param-last
const reducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case FETCH_SETTINGS:
    case FETCH_SETTINGS_ERROR: {
      return {
        ...state,
        settingsResponse: null,
      };
    }
    case FETCH_SETTINGS_SUCCESS: {
      return {
        ...state,
        settingsResponse: payload,
      };
    }
    default: {
      return state;
    }
  }
};

export default reducer;
